import { render } from "./AddGroup.vue?vue&type=template&id=e6720c06&scoped=true&ts=true"
import script from "./AddGroup.vue?vue&type=script&lang=ts"
export * from "./AddGroup.vue?vue&type=script&lang=ts"

import "./AddGroup.vue?vue&type=style&index=0&id=e6720c06&lang=scss&scoped=true"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6720c06"]])

export default __exports__